export default __webpack_public_path__ + "static/media/index-05.0ca4bbca.png";